import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import InputLabel from "@mui/material/InputLabel";
import Button from "@mui/material/Button";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";

const UpdateScoreTimeDialog = ({ value, onChange, onClose, onOk }) => (
  <Dialog onClose={onClose} open={true}>
    <DialogTitle>Update Time</DialogTitle>

    <DialogContent>
      <DialogContentText>
        <InputLabel>Score Time *</InputLabel>
        <TimePicker value={value} onChange={onChange} />
      </DialogContentText>
    </DialogContent>

    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button variant="contained" onClick={onOk}>
        OK
      </Button>
    </DialogActions>
  </Dialog>
);

export default UpdateScoreTimeDialog;
